import React from "react";
import { Leaf, Droplets, CalendarCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefits = [{
  title: "25-Year Warranty",
  description: "Enjoy ultimate peace of mind with industry-leading protection. Our Trex decks include a 25-year limited residential warranty against fading and staining.",
  icon: CalendarCheck
}, {
  title: "Zero Maintenance",
  description: "Forget about the endless cycle of sanding, staining, and painting. A simple soap and water cleaning is all it takes to keep your deck looking brand new.",
  icon: Droplets
}, {
  title: "Sustainable Build",
  description: "Our composite decks are engineered from up to 95% recycled materials, combining high-performance durability with environmental responsibility.",
  icon: Leaf
}];
export default function SubscriptionBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="34195" id="key-benefits-of-composite-trex-decks" ref={ref} className="bg-background text-foreground py-32 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className={cn("grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {benefits.map((benefit, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full border border-border/50 bg-card/60 backdrop-blur-md shadow-sm transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:shadow-primary/5 hover:border-ring/50 group">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex items-center justify-center rounded-sm bg-accent p-3 w-fit group-hover:bg-accent/80 transition-colors">
                    <benefit.icon className="size-8 text-ring" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-3xl font-default font-bold text-foreground leading-tight tracking-tight">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base font-sans text-muted-foreground leading-relaxed">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}